import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import MapWithMarkers from '../../components/service/PropertyList';
import './Home.css';
import Header from '../../components/Header/Header';

import 'leaflet/dist/leaflet.css';
import 'leaflet-defaulticon-compatibility';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css';
import { FaMapMarkedAlt, FaChartLine, FaCogs, FaCheckCircle } from 'react-icons/fa';
import gta from '../../assets/gta.png'; // فایل تصویری خودت
// import layer_ai from '../../../public/'; // فایل تصویری خودت
import logo from '../../assets/logo.png'
import problem from '../../assets/problem.png'
import key_features from '../../assets/key_features.png'
import AboutUs from '../../components/AboutUs/AboutUs';

import '@fortawesome/fontawesome-free/css/all.min.css';



export default function Home() {
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();
  const handleGetStarted = () => {
    navigate('/properties');
    // navigate('/properties');
  };


  const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;


  {/* <MapWithMarkers key={refresh} /> */ }
  return (
    <div className="w-full min-h-screen bg-white text-gray-800 font-sans">
      

      <section className="hero">
        <div className="hero-overlay" />

        <div className="hero-content">
          <div className="hero-tagline">
            • UrbanScore
          </div>

          <h1 className="hero-title">
            Multi-layer AI scoring for{" "}
            <span>smarter urban development</span>
          </h1>

          <p className="hero-subtitle">
            We combine 7–10 planning layers – Official Plans, transit, zoning,
            secondary plans and more – into one clear 0–10 score for every
            Application.
          </p>

          <div className="hero-actions">
            <Link to="/scoring-system" className="hero-btn hero-btn-primary">
              Explore the scoring system
            </Link>

            <Link to="/demo" className="hero-btn hero-btn-secondary">
              Watch a 2-minute overview
            </Link>
          </div>
        </div>
      </section>

      <section className="us-section">
        <div className="us-left">
          <h2 className="us-title">What Is UrbanScore?</h2>

          <p className="us-text">
            UrbanScore is an AI-powered analysis engine that evaluates the development potential of any Application in seconds.
            We combine urban planning policy, geospatial data, and open municipal datasets to produce a clear 0–10 score that reflects how well a Application aligns with long-term city vision.

            Our mission is simple:
            Turn complex planning rules into easy, data-driven decisions.
          </p>

          <h2 className="us-title">Why UrbanScore Matters</h2>
          Cities like Toronto and York Region have advanced planning policies — but it’s difficult for planners, investors, and developers to analyze all this information manually.

          UrbanScore solves this by:
          <ul className="us-list">
            <li>
              <span>Reading multiple planning layers at onces.</span>
            </li>
            <li>
              <span>Measuring distances to key features</span>
            </li>
            <li>
              <span>Checking compliance with official plan policies</span>
            </li>
            <li>
              <span>Scoring each Application consistently and objectively</span>
            </li>
          </ul>
          Urban development becomes faster, fairer, and more transparent.
        </div>

        <div className="us-right">
          <div className="us-image-frame">
            <img src=" /urbanscore.png" alt="UrbanScore Map" />
          </div>
        </div>
      </section>

      <section className="feature-section">
        <div className="feature-image">
          <img src='layers.png' alt="Team working" />
        </div>
        <div className="feature-text">
          <h2>How does it work?</h2>
          <p>
            UrbanScore analyzes the true development potential of every Application by combining ten essential planning layers into a single, data-driven score. It evaluates how well a site aligns with Official Plan policies, measures access to transit routes and stations, and checks whether the Application is located within secondary plans or strategic growth areas. The system assesses zoning and density permissions, identifies connections to growth centres and corridors, and flags any environmental or greenlands constraints that may shape development. UrbanScore also analyzes proximity to community services, monitors nearby development activity to understand market momentum, evaluates available infrastructure capacity, and measures walkability and urban form to determine how well the site supports complete-community principles. Together, these layers generate a clear, objective 0–10 score that reflects a Application’s long-term planning alignment and real-world development opportunity.
          </p>

        </div>



      </section>

      <section className="us-section">
        <div className="us-left">
          <h2 className="us-title">Who Urbanscore Help</h2>

          <p className="us-text">
            UrbanScore supports the entire development ecosystem by giving each stakeholder the insights they need to make faster, smarter decisions. Municipalities can prioritize development applications more effectively, reduce review times, improve transparency, and ensure growth stays aligned with Official Plan objectives. Developers and investors benefit from the ability to quickly identify high-potential lots, reduce project risk, and instantly understand key planning and policy constraints. Urban planners gain powerful tools for automating early-stage analysis, saving time on data interpretation, and producing consistent, objective reports that strengthen the planning process from start to finish. 

            Our mission is simple:
            Turn complex planning rules into easy, data-driven decisions.
          </p>


        
        </div>

        <div className="us-right">
          <div className="us-image-frame">
            <img src=" /urbanscore_help.png" alt="UrbanScore Map" />
          </div>
        </div>
      </section>
      <section className="start_service_container">
        <h2 >Smart Urban Property Analysis in Toronto & GTA</h2>
        <div className='sub_start_service_container'>
          <p className="max-w-2xl text-lg text-gray-700 mb-6">
            Accurate scoring powered by Open Data, permit insights, geolocation, and growth center analysis.
          </p>
          <button className="get_start_service" onClick={handleGetStarted}>Get Started</button>
        </div>
      </section>

      <section id="problem" className="problem_container">
        <h2 id='xx' className="text-2xl font-bold mb-10 text-center">Problem & Solution</h2>
        <div className="sub_problem_container">
          <img id='problem_img' src={problem} />
          <div id='xx' className="flex flex-col md:flex-row items-center gap-6 bg-red-50 p-6 rounded-xl shadow-md">
            <i id='icon_problem_solution' className="fa-solid fa-triangle-exclamation"></i>
            <div className="sub_problem_container_text">
              <h3 className="font-bold text-lg mb-2">The Problem</h3>
              <ul className="list-disc pr-5 text-sm text-gray-700">
                <li>Lack of actionable insights for urban development planning</li>
                <li>Disorganized or outdated municipal data sources</li>
                <li>Gaps between investor needs and city data</li>
              </ul>
            </div>
          </div>

          <div id='xx' className="flex flex-col md:flex-row-reverse items-center gap-6 bg-green-50 p-6 rounded-xl shadow-md">
            <i id='icon_problem_solution' class="fa-solid fa-lightbulb"></i>
            <div className="sub_problem_container_text">
              <h4 className="font-bold text-lg mb-2">Our Solution</h4>
              <ul className="list-disc pr-5 text-sm text-gray-700">
                <li>Real-time permit and zoning data integration</li>
                <li>Automated Application scoring engine</li>
                <li>Interactive map dashboard with advanced filters</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="features" className="bg-orange-50 p-12">

        <h2 className="title_key">Key Features</h2>
        <div id='container_key_features' className="grid md:grid-cols-3 gap-6 text-sm text-gray-700">

          <img id='features_img' src={key_features} />
          <div id='container_text_key' >

            <div className="text_key_features">
              <FaMapMarkedAlt id='icon_key_features' />
              Property analysis using official municipal datasets
            </div>
            <div className="text_key_features">
              <FaChartLine id='icon_key_features' className="text-orange-500 text-lg" />
              Growth center and strategic corridor detection
            </div>
            <div className="text_key_features">
              <FaCogs id='icon_key_features' className="text-orange-500 text-lg" />
              Direct API access to Toronto & York Open Data
            </div>
            <div className="text_key_features">
              <FaMapMarkedAlt id='icon_key_features' className="text-orange-500 text-lg" />
              Map dashboard with region-level filters
            </div>
            <div className="text_key_features">
              <FaChartLine id='icon_key_features' className="text-orange-500 text-lg" />
              Report generation for municipalities and developers
            </div>
            <div className="text_key_features">
              <FaCheckCircle id='icon_key_features' className="text-orange-500 text-lg" />
              Intelligent location-based Application scoring system
            </div>
          </div>

        </div>
      </section>
            <AboutUs/>


      <section id="contact" className="p-12 bg-orange-100">
        <h3 className="text-2xl font-bold mb-4">Contact Us</h3>
        <div className='container_form_contact'>

          <p className="text-white-700 mb-4">Fill out the form below to connect with our team or request a live demo.</p>
          <form className="form">
            <input type="text" placeholder="Your Name" className="p-3 rounded-lg border" />
            <input type="email" placeholder="Email" className="p-3 rounded-lg border" />
            <textarea placeholder="Your Message" className="p-3 rounded-lg border md:col-span-2" rows="4"></textarea>
            <button className="bg-orange-500 text-white px-6 py-3 rounded-lg md:col-span-2 hover:bg-orange-600">Send Message</button>
          </form>
        </div>
        <footer id='footer' className="p-6 text-center text-gray-500 text-sm bg-orange-50">
          &copy; {new Date().getFullYear()} UrbanScore  Designed by Milad Amiri | All rights reserved.
        </footer>
      </section>



      




    </div>
  );
}